import { Stack } from "react-bootstrap"
import useUXStore from "../api/ux/store"
import { PageUnit } from "../api/ux/data"
import Account from "./AccountDropdown"

type NavigationProps = {
    initialPage : PageUnit
}

const Navigation :React.FC<NavigationProps> = ({initialPage}) => {
    const { currentPage, pages, pushPage, popAt } = useUXStore( state => state)
    if (currentPage === null) {
        pushPage(initialPage.Label, initialPage.Element)
        return initialPage.Element
    }
    const onClickPage = (index:number) => {
        popAt(index)
    }

    return (
        <>
            <Stack className="nav-header-bar" direction="horizontal" gap={3}>
                {
                pages.map((page, index) => (
                    index < pages.length -1 ? 
                        <div className="nav-header-inactive" onClick={(_) => onClickPage(index)}>
                            {page.Label}
                        </div> :
                        <div className="nav-header-active">{page.Label}</div>
                ))
                }
                <Account />
            </Stack>

            {currentPage.Element}
        </>
    )
}

export default Navigation